import React, { ReactNode, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import SubscriptionCRUDActions from '@mm/state/actions/SubscriptionCRUDActions';
import ConnectedPageCRUDActions from '@mm/state/actions/ConnectedPageCRUDActions';
import PromotionsCRUDActions from '@mm/state/actions/PromotionsCRUDActions';
import { useSafeState } from '../../../common/hooks/use-safe-state';

type OuterProps = {
  children: ReactNode | Element[];
};

type InnerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & InnerProps;

const FetchBillingData = (props: Props) => {
  const {
    children,
    getAccountData,
    company,
    clearAccountData,
    getPages,
    getPromotionsList,
  } = props;
  const [fetchComplete, setFetchComplete] = useSafeState(false);
  const companyId = company ? company.id : undefined;

  useEffect(() => {
    const fetchOnCompanyUpdate = async () => {
      setFetchComplete(false);
      const requests: Promise<any>[] = [];

      if (companyId && company) {
        requests.push(getPages(companyId));
        requests.push(getAccountData(companyId));

        if (company.editable) {
          requests.push(getPromotionsList(companyId));
        }

        await Promise.all(requests);
      } else {
        clearAccountData();
      }

      setFetchComplete(true);
    };

    fetchOnCompanyUpdate();
  }, [companyId]);

  return fetchComplete ? <>{children}</> : null;
};

const mapStateToProps = (state: StoreState) => ({
  company: activeCompanySelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  getAccountData: (companyId: number) =>
    dispatch(SubscriptionCRUDActions.getAccountData(companyId)),
  clearAccountData: () => dispatch(SubscriptionCRUDActions.clearAccountData()),
  getPages: (companyId: number) =>
    dispatch(
      ConnectedPageCRUDActions.retrieveBasicListByCompany(companyId, {
        withSubscription: true,
        withDowngradePending: true,
        withMessagesStatistic: true,
        showInstagramAccounts: true, // BE return square_picture in response
      }),
    ),
  getPromotionsList: (companyId: number) =>
    dispatch(PromotionsCRUDActions.getPromotions(companyId)),
});

const enhance = compose<InnerProps, OuterProps>(
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(FetchBillingData);
